import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, Effect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { Observable, pipe } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { switchMap, tap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { AuthActionTypes, LogIn, LogInSuccess, LogInFailure, LogOut } from '../actions/auth.actions';
import { Credentials } from '../../model/user/credentials';
import { User } from '../../model/user/User';
import { INIT, UPDATE } from '@ngrx/store';
import { REFRESH } from '@ngrx/store-devtools/src/actions';


@Injectable()
export class AuthEffects {

  returnUrl: string;

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  // effects go here
  @Effect()
  LogIn: Observable<any> = this.actions$.pipe(
    ofType(AuthActionTypes.LOGIN),
    tap(() => console.log(AuthActionTypes.LOGIN + 'Effect - login')),
    map((action: LogIn) => action.payload),
    switchMap(payload => {
      return this.authService.login(new Credentials(payload.email, payload.password))
        .map((user) => {
          this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/landing';
          console.log('RETURN URL: ', this.returnUrl);
          return new LogInSuccess({ // DTO RECEIVED FROM SERVER
            email: payload.email,
            name: user.name,
            surname: user.surname,
            ssn: user.ssn,
            phoneNumber: user.phoneNumber,
            role: user.role,
            birthDate: user.birthDate,
            birthPlace: user.birthPlace,
            doctorID: user.doctorID,
            chatNotificationEnabled: user.chatNotificationEnabled,
            doctor: user.doctor,
            bodyStat: user.bodyStat,
            questionnaires: user.questionnaires,
            jwt: user.jwt,
            expiration: user.expiration,
            notifications: user.notifications
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new LogInFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  LogInSuccess: Observable<any> = this.actions$.pipe(
    ofType(AuthActionTypes.LOGIN_SUCCESS),
    tap((user) => {

      const u: User = {
        email: user.payload.email,
        name: user.payload.name,
        surname: user.payload.surname,
        ssn: user.payload.ssn,
        phoneNumber: user.payload.phoneNumber,
        role: user.payload.role,
        birthDate: user.payload.birthDate,
        birthPlace: user.payload.birthPlace,
        notifications: user.payload.notifications,
        chatNotificationEnabled: user.payload.chatNotificationEnabled
      };
      const expiration = new Date(user.payload.expiration * 1000).getTime();
      // solo su localhost - 72000000
      // equivalente del codice giù -> rifattorizzato a 2 ore in meno per come arriva dal server
      /*const h = expiration.getHours();
      expiration.setHours(h - 2);*/

      switch (user.payload.role) {
        case 'DOTTORE': {
          localStorage.setItem('user', JSON.stringify(u));
          localStorage.setItem('jwt', JSON.stringify(user.payload.jwt));
          localStorage.setItem('expirationTime', JSON.stringify(expiration));
          localStorage.setItem('doctorID', JSON.stringify(user.payload.doctorID));
          break;
        }
        case 'PAZIENTE': {
          localStorage.setItem('user', JSON.stringify(u));
          localStorage.setItem('jwt', JSON.stringify(user.payload.jwt));
          localStorage.setItem('expirationTime', JSON.stringify(expiration));
          localStorage.setItem('doctor', JSON.stringify(user.payload.doctor));
          //localStorage.setItem('bodyStat', JSON.stringify(user.payload.bodyStat));
          localStorage.setItem('questionnaires', JSON.stringify(user.payload.questionnaires));
          break;
        }
        case 'AMMINISTRATORE': {
          localStorage.setItem('user', JSON.stringify(u));
          localStorage.setItem('jwt', JSON.stringify(user.payload.jwt));
          localStorage.setItem('expirationTime', JSON.stringify(expiration));
          break;
        }
      }
      // set firebase token and send to server
      const token = localStorage.getItem('firebase-token');
      this.authService.subscribeToTopic(u.email, token);
      this.authService.keepAliveSession();
      // end
      this.router.navigateByUrl(this.returnUrl);
    })
  );

  @Effect({ dispatch: false })
  LogInFailure: Observable<any> = this.actions$.pipe(
    ofType(AuthActionTypes.LOGIN_FAILURE)
  );

  @Effect({ dispatch: false })
  $init = this.actions$.pipe(
    ofType(ROOT_EFFECTS_INIT),
    pipe(
      map(action => {
        if (this.authService.getToken() && !this.authService.expired()) {
          this.authService.keepAliveSessionAfterRefresh();
        }
      }))
  );

  @Effect({ dispatch: false })
  public LogOut: Observable<any> = this.actions$.pipe(
    ofType(AuthActionTypes.LOGOUT),
    tap(() => {
      this.authService.logout();
      const token = localStorage.getItem('firebase-token');
      localStorage.clear();
      localStorage.setItem('firebase-token', token);
      this.router.navigate(['/login']);
    })
  );

}
